import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import HotAnimeSection from './components/HotAnimeSection';
import FeaturedSection from './components/FeaturedSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = '樱花动漫-用手机观看动漫的网站-免费樱花动漫-樱花动漫网';
  }, []);

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '樱花动漫网-首页',
          description: t('专为移动端设计的免费动漫平台'),
          url: 'http://kktyvqy.cn/',
          isPartOf: {
            '@type': 'WebSite',
            name: '樱花动漫网',
            url: 'http://kktyvqy.cn/',
          },
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <HotAnimeSection />
        <FeaturedSection />
        <TestimonialsSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}